import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/enterprise-8-poe.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const enterprise8PoE: Product = {
  id: "enterprise8PoE",
  productTitle: "Enterprise 8 PoE",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/switch-enterprise-8-poe"],
  storePathParts: {
    productSlug: "switch-enterprise-8-poe",
    category: "switching-utility",
  },
  sku: "USW-Enterprise-8-PoE",
  description: "enterprise8PoE.description",
  descriptionMaxWidth: 130,
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '200 x 248 x 44 mm\n(7.9 x 9.8 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "8" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "string",
        value: "(8) 2.5 GbE RJ45\n(2) 10G SFP+",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "2.5 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "string",
        value: "PoE+",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "120 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktopWall",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
